import { Component, Input } from '@angular/core';
import { v4 } from "uuid";

@Component({
    selector: 'oaibox-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.css']
})
export class MenuComponent {

  @Input() public disabled: boolean = false;
  @Input() public placement?: 'start' | 'end';

  protected readonly buttonId: string = v4();
  protected dropdownListId: string = v4();
}
